// ----------------------------------------------------------------------

function productTokens(theme) {
  const isLight = theme.palette.mode === 'light';

  if (isLight) {
    return {
      '--product-canvas': '#FFFFFF',
      '--product-canvas-soft': '#F8FCF8',
      '--product-surface': '#FFFFFF',
      '--product-surface-neutral': '#F4F6F8',
      '--product-text': '#212B36',
      '--product-text-secondary': '#637381',
      '--product-text-disabled': '#919EAB',
      '--product-divider': 'rgba(145, 158, 171, 0.24)',
      '--product-primary-soft': '#C8FACD',
      '--product-accent-text': '#005249',
      '--product-warning-bg': '#FEF3C7',
    };
  }

  return {
    '--product-canvas': theme.palette.background.default,
    '--product-canvas-soft': '#1C252E',
    '--product-surface': theme.palette.background.paper,
    '--product-surface-neutral': 'rgba(145, 158, 171, 0.16)',
    '--product-text': '#FFFFFF',
    '--product-text-secondary': '#919EAB',
    '--product-text-disabled': '#919EAB',
    '--product-divider': 'rgba(145, 158, 171, 0.24)',
    '--product-primary-soft': 'rgba(54, 179, 126, 0.22)',
    '--product-accent-text': '#86E8AB',
    '--product-warning-bg': 'rgba(255, 171, 0, 0.16)',
  };
}

export default function CssBaseline(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
          colorScheme: theme.palette.mode,
          ...productTokens(theme),
        },
        body: {
          width: '100%',
          height: '100%',
          ...productTokens(theme),
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
      },
    },
  };
}
